import _ from "lodash";
import { BaseController } from "../../../../common/base/controller";

const ListItems = [
	"transferAllSecurities",
	"disposeSecuritiesAccount",
	"transferCapitalLoss",
	"disposeSavingsPlan",
	"disposeExemptionOrder",
	"sellFragments",
];

class TransferListController extends BaseController {
	isCollapsed = false;
	columns = 1;

	constructor(controllerService, $scope, configService) {
		"ngInject";
		super({
			controllerService,
			$scope,
			configService,
		});
	}

	$onInit() {
		this.translateKey = this.translateKey || "oldPortfolioState";
		this.transferList = ListItems.map((item) => {
			return { key: item, value: this.list[item] };
		})
			.filter((x) => angular.isDefined(x.value))
			.sort((a, b) => b.value - a.value);

		// austria specialities
		if (this.configService.isAustrianTenant()) {
			_.remove(this.transferList, { key: "disposeExemptionOrder" });
			_.remove(this.transferList, { key: "transferCapitalLoss" });

			this.transferList.push({
				key: "informFinanzamtAboutSwitch",
				value: this.list.informFinanzamtAboutSwitch,
			});
		}

		if (this.collapse) {
			this.isCollapsed = true;
		}
	}

	getTranslateKey(key) {
		return `app.${this.translateKey}.${key}`;
	}
}

export default TransferListController;



// WEBPACK FOOTER //
// ./src/app/components/overview/components/transferList/transferList.controller.js